import { AccountData } from './account-data';

export interface AccountSubscriptionUsersData {
    accountId?: string;
    subscriptionId?: string;
    users: SubscriptionUserData[];
    account?: AccountData;
    lastEvaluatedKey?: {
        PK: string;
        SK: string;
    }
}

export interface SubscriptionUserData {
    userId: string;
    userName: string;
    userSub?: boolean | string;
}